import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { useLang } from "@/i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking");
  const { t } = useLang();

  useEffect(() => {
    if (!sessionId) { setState("error"); return; }
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setState("paid"); return; }
      } catch { /* retry */ }
      attempts++;
      if (attempts < 15) setTimeout(poll, 2000);
      else setState("error");
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#0A0A0C] text-white flex items-center justify-center px-6">
      <div className="max-w-lg w-full text-center border border-[#27272A] bg-[#121214] p-12">
        <img src="/assets/logo-dark-sm.png" alt="D2R" className="h-12 w-auto mx-auto mb-10" />
        {state === "checking" && (
          <>
            <Loader2 size={36} className="animate-spin text-[#C5A059] mx-auto" />
            <h1 className="font-display text-3xl uppercase font-bold mt-8">{t("pay.success.checking")}</h1>
            <p className="text-[#71717A] text-sm mt-4">{t("pay.success.wait")}</p>
          </>
        )}
        {state === "paid" && (
          <>
            <CheckCircle2 size={36} className="text-[#C5A059] mx-auto" />
            <h1 className="font-display text-3xl uppercase font-bold mt-8" data-testid="payment-success-title">
              {t("pay.success.t1")} <span className="text-[#C5A059]">{t("pay.success.t2")}</span>
            </h1>
            <p className="text-[#A1A1AA] text-sm mt-4 leading-relaxed">
              {t("pay.success.text")}
            </p>
            <p className="font-editorial italic text-[#C5A059] mt-6">{t("pay.success.quote")}</p>
          </>
        )}
        {state === "error" && (
          <>
            <XCircle size={36} className="text-red-400 mx-auto" />
            <h1 className="font-display text-3xl uppercase font-bold mt-8">{t("pay.success.error.t")}</h1>
            <p className="text-[#A1A1AA] text-sm mt-4">
              {t("pay.success.error.x")}
            </p>
          </>
        )}
        <Link
          to="/"
          data-testid="payment-success-home"
          className="inline-block mt-10 border border-[#C5A059] text-[#C5A059] px-8 py-3.5 text-xs uppercase tracking-[0.25em] hover:bg-[#C5A059] hover:text-black transition-colors duration-300"
        >
          {t("pay.back")}
        </Link>
      </div>
    </div>
  );
}
